import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

const CarouselSettings = {
    showStatus: false,
    showThumbs: false,
    infiniteLoop: true,
};

const Slider = ({ values }) => (
   
    <Carousel {...CarouselSettings}>
        {values.map((value, index) => (
            <div key={`figure${index}`}>
                <a className="slider__link" href={value.url}>
                    {/* <img className="slider__image" src={value.image} /> */}
                    <div className="slider__image" dangerouslySetInnerHTML={{ __html: value.image }}></div>
                    <div className="slider__content">
                        <div className="text-on-bg text-on-bg--centered text-on-bg--textshadow">
                            {value.text &&                            
                                <h3 className="text-on-bg__header">{value.text}</h3>
                            }
                            {value.content &&
                                <p>{value.content}</p>
                            }
                            {value.actionText && value.actionText.length > 0 && (
                                <span className="button">
                                    {value.actionText}
                                </span>
                            )}
                        </div>
                    </div>
                </a>

            </div>
        ))}
    </Carousel>
);

export default Slider;
